import React from 'react';
import PropTypes from 'prop-types';

import ZScoreField from './ZScoreField';

class ZScoreFieldsComponent extends React.PureComponent {
  renderLeftZField = (label, wrapperClassName) => (
    <ZScoreField
      id="left-z"
      name="leftZScore"
      label={label}
      wrapperClass={wrapperClassName}
      onChange={this.props.onLeftZScoreChange}
      validate={this.props.validateLeftZScoreFn}
    />
  );

  renderRightZField = (label, wrapperClassName) => (
    <ZScoreField
      id="right-z"
      name="rightZScore"
      label={label}
      wrapperClass={wrapperClassName}
      onChange={this.props.onRightZScoreChange}
      validate={this.props.validateRightZScoreFn}
    />
  );

  render () {
    return (
      <div>
        {this.props.isLeftZScoreFieldVisible && !this.props.isRightZScoreFieldVisible && (
          <div className="flex align-center  mb-20">
            {this.renderLeftZField('z = ', 'width-48')}
          </div>
        )}

        {this.props.isRightZScoreFieldVisible && !this.props.isLeftZScoreFieldVisible && (
          <div className="flex align-center  mb-20">
            {this.renderRightZField('z = ', 'width-48')}
          </div>
        )}

        {this.props.isRightZScoreFieldVisible && this.props.isLeftZScoreFieldVisible && !this.props.isCenterChosen && (
          <div className="flex space-between baseline main-input--inline mb-20">
            <div className=" main-input--inline width-48">
              {this.renderLeftZField('z\u2081 = ', '')}
            </div>
            <div className=" main-input--inline width-48">
              {this.renderRightZField('z\u2082 = ', '')}
            </div>
          </div>
        )}

        {this.props.isRightZScoreFieldVisible && this.props.isLeftZScoreFieldVisible && this.props.isCenterChosen && (
          <div className="flex space-between baseline main-input--inline mb-20">
            <div className=" main-input--inline width-48">
              {this.renderLeftZField('z\u2081 = ', '')}
            </div>
            <div className=" main-input--inline width-48">
              {this.renderRightZField('z\u2082 = ', '')}
            </div>
          </div>
        )}
      </div>
    );
  }
}

ZScoreFieldsComponent.propTypes = {
  isLeftZScoreFieldVisible: PropTypes.bool.isRequired,
  isRightZScoreFieldVisible: PropTypes.bool.isRequired,
  isCenterChosen: PropTypes.bool.isRequired,

  onLeftZScoreChange: PropTypes.func.isRequired,
  onRightZScoreChange: PropTypes.func.isRequired,

  validateLeftZScoreFn: PropTypes.func.isRequired,
  validateRightZScoreFn: PropTypes.func.isRequired
};

export default ZScoreFieldsComponent;
